// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom_footer_wrapper {
  width: 100%;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #100f0f;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.bottom_footer_inner_div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10%;
}

.bottom_footer_copyright_p {
  color: #fff;
  font-family: "Roboto";
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

.bottom_footer_policy_div {
  width: auto;
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.bottom_footer_policy_div > p {
  color: #fff;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}







@media screen and (max-width: 600px) {

    .bottom_footer_inner_div {
        padding: 20px;
      }

      .bottom_footer_policy_div {
        gap: 20px;
      }
}







@media screen and (max-width: 450px) {

    .bottom_footer_inner_div {
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        padding: 20px 10%;
      }

    .bottom_footer_inner_div {
        padding: 20px;
      }

      .bottom_footer_policy_div {
        gap: 20px;
        margin: 10px 0 14px 0;
      }

      .bottom_footer_policy_div > p {
        font-size: 14px;
      }
}`, "",{"version":3,"sources":["webpack://./src/components/common/footer/bottomFooter.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;;;;;;AAQA;;IAEI;QACI,aAAa;MACf;;MAEA;QACE,SAAS;MACX;AACN;;;;;;;;AAQA;;IAEI;QACI,uBAAuB;QACvB,uBAAuB;QACvB,sBAAsB;QACtB,iBAAiB;MACnB;;IAEF;QACI,aAAa;MACf;;MAEA;QACE,SAAS;QACT,qBAAqB;MACvB;;MAEA;QACE,eAAe;MACjB;AACN","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.bottom_footer_wrapper {\n  width: 100%;\n  display: flex;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #100f0f;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.bottom_footer_inner_div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 10%;\n}\n\n.bottom_footer_copyright_p {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n}\n\n.bottom_footer_policy_div {\n  width: auto;\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n}\n\n.bottom_footer_policy_div > p {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n    .bottom_footer_inner_div {\n        padding: 20px;\n      }\n\n      .bottom_footer_policy_div {\n        gap: 20px;\n      }\n}\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n    .bottom_footer_inner_div {\n        align-items: flex-start;\n        justify-content: center;\n        flex-direction: column;\n        padding: 20px 10%;\n      }\n\n    .bottom_footer_inner_div {\n        padding: 20px;\n      }\n\n      .bottom_footer_policy_div {\n        gap: 20px;\n        margin: 10px 0 14px 0;\n      }\n\n      .bottom_footer_policy_div > p {\n        font-size: 14px;\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
